import axios from 'axios';
import { IContactUsDto } from './contact-us-form-dto.interface';

export const getLinkToContactForm = () => {
    return `/Home/ContactForm`;
};
export const getLinkToContactSuccess = () => {
    return `/Home/ContactSuccess`;
};
export function contactUs(dto: IContactUsDto) {
    return axios.post(`UserSupport/ContactUs`, dto);
}
export const getLinkToVisitUs = () => {
    return `/Home/Difference`;
};
export const htmlId: string = 'fixcenter-support-contact-us-form';
